import { createRestClient, safeApiCall } from '@/shared/utils/apiHelper';
import { mapResponse } from './mappers';
import { ApiSuccessResponse, ApiErrorResponse } from '@/shared/types/api.types';
import type { Token } from '../models';
import type { GetTokenPayload } from '../payloads';
import type { GetTokenResponse } from './responses';

/**
 * Exchange the code for a JWT.
 *
 * @throws {ApiErrorResponse} If the API call fails.
 */
export async function getToken({
    code,
    codeVerifier,
    origin,
    clientId,
}: GetTokenPayload): Promise<ApiSuccessResponse<Token>> {
    const restClient = createRestClient(null);

    const result = await safeApiCall<GetTokenResponse>(
        restClient('/oauth/gettoken', {
            method: 'POST',
            body: {
                grant_type: 'authorization_code',
                client_id: clientId,
                code,
                code_verifier: codeVerifier,
                redirect_uri: origin,
            },
        }),
    );

    if (result instanceof ApiErrorResponse) {
        throw result;
    }

    return mapResponse(result.data);
}

export async function createSession({ accessToken }: {
    accessToken: string;
}): Promise<true> {
    const restClient = createRestClient(accessToken);

    const result = await safeApiCall<GetTokenResponse>(
        restClient('/user/session', {
            method: 'POST',
        }),
    );

    if (result instanceof ApiErrorResponse) {
        throw result;
    }

    return true;
}
